import { render, staticRenderFns } from "./JigDetail.vue?vue&type=template&id=70533e4d"
import script from "./JigDetail.vue?vue&type=script&lang=ts"
export * from "./JigDetail.vue?vue&type=script&lang=ts"
import style0 from "./JigDetail.vue?vue&type=style&index=0&id=70533e4d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports